import { GetMessageQuery } from "../../generated/graphql";
import React from "react";

type MessageType = GetMessageQuery["getMessage"];

interface Props {
    message: MessageType;
}

export const SendFailureBanner: React.FC<Props> = ({ message }) => {
    const failureEvents = (message.events ?? []).filter(
        e => e.eventType === "email-send-failure",
    );
    if (failureEvents.length === 0) {
        return null;
    }

    const recipients = Array.from(
        new Set(failureEvents.map(e => e.recipient).filter(r => !!r)),
    );

    return (
        <div className="text-sm text-red-700 bg-red-50 rounded p-2">
            {recipients.length > 0 ? (
                <>This message wasn&rsquo;t delivered to: {recipients.join(", ")}.</>
            ) : (
                <>This message wasn&rsquo;t delivered.</>
            )}
        </div>
    );
};
